import * as React from 'react'

export const MenuIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='header-menu-icon'
    >
      <g clipPath='url(#clip0_1987_1420)'>
        <line
          x1='1.85'
          y1='3.15'
          x2='14.15'
          y2='3.15'
          stroke='#64748B'
          strokeWidth='1.7'
          strokeLinecap='round'
        />
        <line
          x1='1.85'
          y1='8.15'
          x2='14.15'
          y2='8.15'
          stroke='#64748B'
          strokeWidth='1.7'
          strokeLinecap='round'
        />
        <line
          x1='8.31094'
          y1='13.15'
          x2='14.1494'
          y2='13.15'
          stroke='#64748B'
          strokeWidth='1.7'
          strokeLinecap='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_1987_1420'>
          <rect width='14' height='12' fill='white' transform='translate(1 2)' />
        </clipPath>
      </defs>
    </svg>
  )
}
